import React from "react";

import { ViewField } from "../../ViewField";

type Form = {
  label: string;
  value?: string;
};

interface ViewModeProps {
  children?: React.ReactNode;
  onViewMode?: boolean;
  formData?: Form;
}

export function ViewModeComponent(props: ViewModeProps) {
  const { children, onViewMode = false, formData } = props;

  return (
    <React.Fragment>
      {onViewMode ? <ViewField label={formData?.label || ""} value={formData?.value} /> : children}
    </React.Fragment>
  );
}
